export const PREFIX = '@@redux-leaflet/'

export const SET_MAP_REF = `${PREFIX}SET_MAP_REF`
export const CLEAR_MAP_REF = `${PREFIX}CLEAR_MAP_REF`
export const SET_MAP_ZOOM = `${PREFIX}SET_MAP_ZOOM`
export const FIT_MAP_BOUNDS = `${PREFIX}FIT_MAP_BOUNDS`
export const FLY_TO = `${PREFIX}FLY_TO`
export const SET_VIEW = `${PREFIX}SET_VIEW`
